import { GetStatusesEventFragment } from './getStatuses.generated-types'

interface Statuses {
  isAwaitingResponses: boolean
  isActiveWithResponses: boolean
  isRequestedToBook: boolean
  isBookingCancelled: boolean
  isBookingConfirmed: boolean
  noResponseWasChosen: boolean
}

export const getStatuses = ({ proposalCount, status }: GetStatusesEventFragment): Statuses => {
  return {
    isAwaitingResponses:
      status === 'Created' ||
      status === 'HostsInvited' ||
      status === 'ProposalsReceived' ||
      (proposalCount === 0 && status !== 'Cancelled'),
    isBookingCancelled: status === 'Cancelled',
    isRequestedToBook: false,
    isBookingConfirmed: status === 'RequestedToBook',
    isActiveWithResponses:
      status === 'ProposalsSent' || (proposalCount > 0 && status === 'AwaitingDecision'),
    noResponseWasChosen: status === 'NoResponseChosen',
  }
}
